const CURRENCY_SYMBOLS: Record<string, string> = {
  eur: "€",
  usd: "$",
  gbp: "£",
  jpy: "¥",
  chf: "CHF",
  cad: "C$",
  aud: "A$",
  nzd: "NZ$",
};

/**
 * Formats an EAC price or premium date (date-only or ISO datetime) as a locale date.
 * Returns an empty string for an empty input.
 */
export const formatPricingDate = (date: string): string => {
  if (!date) return "";
  // Handle both date-only and datetime formats
  const dateOnly = date.split("T")[0];
  return new Date(dateOnly).toLocaleDateString();
};

/**
 * Formats a datetime string as a locale date and time.
 */
export const formatPricingDateTime = (dateStr: string): string => {
  return new Date(dateStr).toLocaleString();
};

/**
 * Maps a currency code (any case) to its symbol, falling back to the upper-cased code.
 * Returns an empty string when no currency is given.
 */
export const getCurrencySymbol = (currency: string | null): string => {
  if (!currency) {
    return "";
  }

  return CURRENCY_SYMBOLS[currency.toLowerCase()] ?? currency.toUpperCase();
};

/** Formats a bid, ask or mid price to two decimals; a missing price shows as "-". */
export const formatPriceOrDash = (value: number | null): string => {
  return value !== null ? value.toFixed(2) : "-";
};
